<template>
    <div class="card-container">
        <common-top-form
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            @openAddDialog="openAddDialog"
            addShowPower="/giftpackmanage/add"
            :selectShow="false"
            :show="false"
        >
        </common-top-form>
        <common-table :data="tableData" ref="commonTable">
            <el-table-column
                prop="name"
                label="礼包名称"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="giftLevel"
                label="礼包等级"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="machineNum"
                label="机具数量"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                v-if="hasPerm('/giftpackmanage/caozuo')"
                label="操作"
                min-width="100"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button type="text" @click="openAddDialog(scope.row)"
                    >发送
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            formDialogTitle="发送"
            :model="dialogModel"
            :submitData="dialogData"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
            labelWidth="120px"
            dialogWidth="439px"
        >
            <el-form-item label="礼包名称" prop="name">
                <el-input
                    type="text"
                    maxlength="100"
                    :disabled="true"
                    v-model="dialogModel.name"
                    placeholder="请输入"
                    style="width: 180px"
                ></el-input>
            </el-form-item>
            <el-form-item label="代理商ID" prop="targetAgentId">
                <el-input
                    type="text"
                    maxlength="100"
                    v-model="dialogModel.targetAgentId"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="代理商姓名" prop="realName">
                <el-input
                    disabled
                    type="text"
                    maxlength="100"
                    v-model="memName.realName"
                ></el-input>
            </el-form-item>
            <el-form-item label="代理商手机号" prop="phoneNumber">
                <el-input
                    disabled
                    type="text"
                    maxlength="100"
                    v-model="memName.phoneNumber"
                ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input
                    v-model="dialogModel.remark"
                    maxlength="200"
                    show-word-limit
                    type="textarea"
                    rows="3"
                ></el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";

    import ShopService from "service/ShopService";
    import FinanceService from "service/FinanceService";

    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "giftpackmanage",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                memName: {},
                show: false,
                formModel: {},
                tableData: [],
                page: {},
                submitService: ShopService.giftpackmanageList,
                itemId: "",
                dialogModel: {
                    name: "",
                    remark: "",
                    targetAgentId: "",
                },
                dialogRules: {
                    remark: [
                        {
                            required: true,
                            message: "请输入",
                        }],
                    targetAgentId: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error("请输入"));
                                } else {
                                    this.getRealNameByPhone(value, (res) => {
                                        if (res.respCode == "0000") {
                                            this.memName = res.contents;
                                            if (!this.memName.id) {
                                                this.memName = {};
                                                callback(new Error("查询不到此用户"));
                                            } else {
                                                callback();
                                            }
                                        } else {
                                            callback(new Error("查询不到此用户"));
                                            this.memName = {};
                                        }
                                    });
                                }
                            },
                            trigger: ["change"],
                        },
                    ],
                },
                currentTypes: {},
                dialogService: ShopService.giftpackageput
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                this.params = {
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return this.params;
            },
            dialogData() {
                const params = {
                    targetAgentId: this.dialogModel.targetAgentId,
                    targetGiftId: this.itemId,
                    remark: this.dialogModel.remark,
                };
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        watch: {},
        methods: {
            load() {
                this.formModel = {};
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                        });
                    },
                    "信息获取失败"
                );
            },
            getRealNameByPhone(val, onSuccess) {
                const params = {
                    tatSimpleId: this.tatId,
                    userId: val,
                };
                this.doLoad(
                    FinanceService.getRealNameByPhone,
                    params,
                    (res) => {
                        onSuccess && onSuccess(res);
                    },
                    "信息获取失败"
                );
            },
            handleDelete(item) {
                this.showConfirm("是否删除？")
                    .then(() => {
                        this.doDelete(item.id);
                    })
                    .catch(() => {
                    });
            },
            doDelete(id) {
                this.doLoad(
                    ShopService.giftpackmanageDel,
                    {
                        id: id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            openAddDialog(item, flag) {
                this.itemId = item.id;
                this.dialogModel.name = item.name;
                this.$refs.formDialog.open();
            },
            dialogClose() {
                this.dialogModel = {
                    name: "",
                    remark: "",
                    targetAgentId: "",
                };
                this.itemId = "";
                this.memName = {};
            },
            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/ShopManagement/GiftPackManage.vue